import { SERVER_URL, SERVICE_METHOD, PROJECT_METHOD, HOOK_METHOD, USER_METHOD, UPLOAD_URL } from '../../../constants';
import Toast from 'light-toast';
import {
  setServiceList,
  updateUserList,
  updateServiceList,
  setProjectList,
  updateProjectList,
  setHookList,
  updateHookList,
  setLogsarray,
  setAlerts,
  setLogin,
  setLogsarrayonsearch,
  setDashboardList,
} from '../index';
import { LocalStorageWrap, sendReqToMonitor } from '../../../utils';

export function fetchDashboardData(payload = {}, baseurl, type) {
  return async (dispatch, getState) => {
    try {
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify({
          jsonrpc: '2.0',
          id: 1,
          method: type,
          params: payload,
        }),
        redirect: 'follow',
      };

      let response = await fetch(baseurl, requestOptions);

      if (response.ok) {
        let data = await response.json();

        if (data.error) {
          console.log('Error:', data.error);
        } else {
          const { list, count } = data.result;
          dispatch(setDashboardList({ list, count }));
          return;
        }
      } else {
        console.log('HTTP error:', response.status);
      }
    } catch (err) {
      console.log('Error:', err);
    }
  };
}

export const fetchServiceList = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: SERVICE_METHOD.LIST, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          const list = response?.list;
          const count = response?.count;
          dispatch(setServiceList({ list, count }));
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const getUserList = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: USER_METHOD.LIST, params: payload });

      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const createUser = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: USER_METHOD.CREATE, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          let data1 = response;
          let data = Object.assign(data1, { projectNames: payload?.projectNames });
          dispatch(updateUserList({ data: data, operation: 'create' }));
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const deleteUser = (id) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: USER_METHOD.DELETE, params: { id } });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateUserList({ data: { id }, operation: 'delete' }));
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const editUser = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: USER_METHOD.UPDATE, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateUserList({ data: payload, operation: 'edit' }));
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const fetchServiceDetails = (id) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: SERVICE_METHOD.GET, params: { id } });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const createService = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: SERVICE_METHOD.CREATE, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateServiceList({ data: response, operation: 'create' }));
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const editService = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: SERVICE_METHOD.UPDATE, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateServiceList({ data: payload, operation: 'edit' }));
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const deleteService = (id) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: SERVICE_METHOD.DELETE, params: { id } });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateServiceList({ data: { id }, operation: 'delete' }));
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const fetchProjectList = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: PROJECT_METHOD.LIST, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          const list = response?.list;
          const count = response?.count;
          dispatch(setProjectList({ list, count }));
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const fetchProjectDetails = (id) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: PROJECT_METHOD.GET, params: { id } });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const fetchUserDetails = (id) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: USER_METHOD.GET, params: { id } });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const createProject = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: PROJECT_METHOD.CREATE, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateProjectList({ data: response, operation: 'create' }));
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const editProject = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: PROJECT_METHOD.UPDATE, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateProjectList({ data: payload, operation: 'edit' }));
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const deleteProject = (id) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: PROJECT_METHOD.DELETE, params: { id } });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateProjectList({ data: { id }, operation: 'delete' }));
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};
export const login = ({ username, password }) => {
  return async (dispatch, getstate) => {
    const res = await sendReqToMonitor({ method: USER_METHOD.LOGIN, params: { username, password } });
    if (res)
      LocalStorageWrap.setItem(LocalStorageWrap.USER_DETAILS, {
        username,
        token: res.id,
        role: res.userobj.role,
      });
    dispatch(setLogin({ isLoggedin: true, username, token: res.id, role: res.userobj.role }));
    return {
      username,
      token: res.id,
      role: res.userobj.role,
    };
  };
};

export const Logout = () => async (dispatch) => {
  dispatch(setLogin({ isLoggedin: false, username: '', token: '', role: '' }));
  LocalStorageWrap.removeItem(LocalStorageWrap.USER_DETAILS);
};

export async function SystemHealthApi(payload = {}, token) {
  let response = await fetch(SERVER_URL, {
    method: 'POST',
    body: JSON.stringify({
      jsonrpc: '2.0',
      id: 1,
      method: SERVICE_METHOD.CPU_HEALTH,
      params: payload,
    }),
    headers: { token: token },
  });
  let parsed = await response.json();
  return parsed.result?.list;
}

export const fetchHookList = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: HOOK_METHOD.LIST, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          const list = response?.list;
          const count = response?.count;
          dispatch(setHookList({ list, count }));
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const fetchHookDetails = (id) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: HOOK_METHOD.GET, params: { id } });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const createHook = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: HOOK_METHOD.CREATE, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateHookList({ data: response, operation: 'create' }));
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export function sendHook(payload = {}, token, callback) {
  const formData = new FormData();
  formData.append('hookid', payload.hookid);
  formData.append('to', payload.to);
  formData.append('subject', payload.subject);
  formData.append('text', payload.text);
  for (var i = 0; i < payload.files.length; i++) {
    formData.append(payload.files[i].name, payload.files[i]);
  }

  var myHeaders = new Headers();
  myHeaders.append('token', token);
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: formData,
    redirect: 'follow',
  };
  fetch(UPLOAD_URL, requestOptions)
    .then((response) => response.text())
    .then((response) => {
      if (response.error) {
        Toast.fail('Message not send!');
      }
      callback();
      Toast.success('Message sent!', 1000);
    })
    .catch((err) => {
      console.error(err);
      Toast.fail('Some error occured!');
    });
}
export const editHook = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: HOOK_METHOD.UPDATE, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateHookList({ data: payload, operation: 'edit' }));
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const deleteHook = (id) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: HOOK_METHOD.DELETE, params: { id } });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(updateHookList({ data: { id }, operation: 'delete' }));
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};

export const fetchLogsApi = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: SERVICE_METHOD.LOGS, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(setLogsarray(response?.list));
          return response?.count;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};
export const fetchLogsApionSearch = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: SERVICE_METHOD.LOGS, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          dispatch(setLogsarrayonsearch(response?.list));
          return response?.count;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};
export const fetchAlertsApi = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({ headers: { token }, method: SERVICE_METHOD.ALERTS, params: payload });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          const postArr = response?.list;
          dispatch(setAlerts(postArr));
          return response?.count;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};
export const changePassword = (payload = {}) => {
  return async (dispatch, getState) => {
    try {
      const token = getState().app.user.token;
      const response = await sendReqToMonitor({
        headers: { token },
        method: USER_METHOD.CHANGE_PASSWORD,
        params: payload,
      });
      if (response) {
        if (response.error) {
          console.log('error', response.error);
        } else {
          return response;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
};
